

















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { createPopper } from '@popperjs/core';
import { StatisticsService } from '../services/StaticsService';
import { StatisticsRequestResponseModel } from '../models/StatisticsRequestResponseModel';
import { StatisticsStatusResponseModel } from '../models/StatisticsStatusResponseModel';
import { StatisticsPanelModel } from '../models/StatisticsPanelModel';
import { StatisticsGetRequestIdResponseModel } from '../models/StatisticsGetRequestIdResponseModel';
import Common from '../helper/Common';
import * as $ from 'jquery';
import { systemTimezone } from '../constants/general';

enum State {
    Loading,
    Error,
    CountsResloved,
    Generating,
    NoCounts,
    Cancelled
}

enum CriteriaRequestStatusType {
    Unknown = 0,
    Submitted = 1,
    InProcess = 2,
    CancelledByUser = 3,
    Complete = 4,
    Failed = 9
}

interface StatisticsReportEntry {
    key: string;
    value: string;
}

interface CurrentlyGenerating {
    detailId: number;
    requestId: number;
}

const mousedownEventName: string = 'mousedown.StatisticsPanelClickOutside';
const apiIntervalFrequency: number = 3000;

@Component({})
export default class StatisticsPanel extends Vue {

    // When component is closed( not showen) and state is InProcess, If you want
    // the component to keep checking status then set to false else true.
    // if true the component will emit results to whoever is listening.
    @Prop({ default: false })
    private keepRunningInBackground!: boolean;

    private currentInterval: any = null;
    private panelIsVisible: boolean = false;
    private entriesGeneratedDate: string = '';
    // set to have option to force toggle different states
    private debugging: boolean = false;
    private updatingNotification: boolean = false;
    private disableGenerate: boolean = false;


    private mousedownEvent: string = mousedownEventName;

    // model that represents component and how to initialize itself
    private statisticsPanel!: StatisticsPanelModel;
    private currentlyGenerating: CurrentlyGenerating | null = null;

    // #region fields used to manage UI

    // manages the state of the panel
    private state: State = State.Loading;
    private errorMessage: string = '';
    private cancelledByUser: string = '';
    private entries: StatisticsReportEntry[] = [];
    private uniqueEntries: StatisticsReportEntry[] = [];
    // popper element
    private currentPopperElement: any = null;
    private currentStatistics: StatisticsRequestResponseModel | null = null;
    // last count recorded, used to emit last count to whoever is listening.
    // (when count completes maybe parent might want to update)
    private lastTotalCount: number | null = null;
    private lastUniqueCount: number | null = null;
    private looping: boolean = false;
    private requesting: number | null = null;
    // #endregion

    // #region public functions

    // make a new statistics request and resets the component
    public fetchStatistics(statistics: StatisticsPanelModel) {
        this.initializeComponent(statistics);
        if (statistics.forceRequest === true) {
            this.generate();
        } else if (statistics.justListen === false && statistics.noCountsGeneratedBefore === true) {
            this.panelIsVisible = true;
            this.updateState(State.NoCounts);
        } else if (statistics.requestId != null && statistics.requestId > 0) {
            this.requestStatusCheck();
        } else {
            this.requestStatistics(false);
        }
    }

    public killStatistics() {
        this.destroyCurentIntervalTimeout();
    }

    public getCurrentStatistics(): StatisticsRequestResponseModel | null {
        return this.currentStatistics;
    }

    // initialize component for request
    private initializeComponent(statistics: StatisticsPanelModel) {
        this.resetComponent();
        if (this.looping && this.statisticsPanel) {
            statistics.requestId = this.statisticsPanel.requestId;
        }
        this.statisticsPanel = statistics;
        this.mousedownEvent = `${mousedownEventName}_${this.statisticsPanel.detailId}`;
        this.initPopOver(this.statisticsPanel.targetElement);
        this.handleClickOutsideEvent(true);
    }

    // #endregion

    // #region functions that affect the UI

    // mounts/unmounts click outside event
    private handleClickOutsideEvent(mountEvent: boolean) {
        const that: any = this;
        if (mountEvent) {
            $(document).bind(this.mousedownEvent, (e) => {
                const container: any = $('#panel');
                // if the target of the click isn't the container nor a descendant of the container
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    if (that.keepRunningInBackground) {
                        that.closeComponent();
                    } else {
                        that.resetComponent();
                    }
                }
            });
            // handle Iframe click inside criteria editor
            $('.criteriaContainer iframe').contents().on('mousedown, mouseup, click', () => {
                if (that.keepRunningInBackground) {
                    that.closeComponent();
                } else {
                    that.resetComponent();
                }
            });
        } else {
            this.unmountClickOutsideEvent();
        }
    }

    private unmountClickOutsideEvent() {
        $(document).unbind(this.mousedownEvent);
        // reset event
        this.mousedownEvent = mousedownEventName;
    }

    // generate a new count
    private generate() {
        this.disableGenerate = true;
        this.requestStatistics(true);
    }

    private disableGenerateBtn(): boolean {
        return this.disableGenerate;
    }

    // cancel count
    private cancel() {
        const that: any = this;
        this.destroyCurentIntervalTimeout();

        this.statisticsPanel.statisticsService.cancelStatisticsRequest()
            .then(() => {
                that.apiCheckStatisticsRequestStatus();
            }).catch(() => {
                this.showError('An error occurred while generating the counts.');
            });
    }

    private debuggingShow(section: string) {
        switch (section) {
            case 'countsResloved':
                this.state = State.CountsResloved;
                break;
            case 'generating':
                this.state = State.Generating;
                break;
            case 'loading':
                this.state = State.Loading;
                break;
            case 'error':
                this.state = State.Error;
                break;
            case 'nocounts':
                this.state = State.NoCounts;
                break;
            default:
                this.state = State.Loading;
                break;
        }
    }

    // used to display sections of the panel based on current state
    private show(section: string): boolean {
        let show: boolean = false;
        switch (section) {
            case 'countsResloved':
                show = this.state === State.CountsResloved;
                break;
            case 'generating':
                // this.disableGenerate = false;
                show = this.state === State.Generating;
                break;
            case 'loading':
                // this.disableGenerate = false;
                show = this.state === State.Loading;
                break;
            case 'error':
                // this.disableGenerate = false;
                show = this.state === State.Error;
                break;
            case 'nocounts':
               // this.disableGenerate = false;
                show = this.state === State.NoCounts;
                break;
            case 'cancelled':
                // .disableGenerate = false;
                show = this.state === State.Cancelled;
                break;
            default:
                break;
        }
        return show;
    }

    // used to display error message and change state of panel
    private showError(message: string) {
        this.looping = false;
        this.errorMessage = message;
        const detailId: number = this.statisticsPanel.detailId;
        // if panel is not being display emit error.
        if (this.keepRunningInBackground && this.panelIsVisible === false) {
            this.$emit('onError', {
                message,
                detailId
            });
        }
        this.updateState(State.Error);
    }

    // #endregion

    // #region function to manage the component's logic

    // makes sure componenet is reset so that no job keeps running in background
    private beforeDestroy() {
        if (this.keepRunningInBackground) {
            this.resetComponent();
        }
    }

    // resets the componet so that there is no statistics running and no popper element created
    private resetComponent() {
        this.disableGenerate = false;
        this.panelIsVisible = false;
        this.destroyPopOver();
        this.entries = [];
        this.uniqueEntries = [];
        this.lastTotalCount = null;
        this.errorMessage = '';
        this.destroyCurentIntervalTimeout();
        this.updateState(State.Loading);
        this.handleClickOutsideEvent(false);
        this.looping = false;
    }

    // closes popup but components keeps running in the background.
    private closeComponent() {
        this.panelIsVisible = false;
        this.destroyPopOver();
        this.handleClickOutsideEvent(false);
    }

    private destroyCurentIntervalTimeout() {
        // Clear timeout interval if exists
        if (this.currentInterval) {
            clearInterval(this.currentInterval);
        }
    }

    private initArrow() {
        const x = document.getElementsByClassName('arrow');
        const p = document.getElementById('panel');
        const xw = $(x).innerWidth();
        const pw = $(p).outerWidth();
        const set = (pw / 2) - (xw / 2) - 2;
        $(x).css({ left: set + 'px' });
    }

    private placeArrow() {
        setTimeout(() => {
            const x = document.getElementsByClassName('arrow');
            const p = document.getElementById('panel');
            const xw = $(x).innerWidth();
            const pw = $(p).outerWidth();
            const set = (pw / 2) - (xw / 2) - 2;
            $(x).css({ left: set + 'px' });
            // console.log(xw);
        }, 50);
    }

    // initializes the popover given a target
    private initPopOver(target: HTMLElement) {
        // content that will be displayed inside the popover.
        const content: HTMLElement = document.getElementById('panel') as HTMLElement;
        const options: any = {
            placement: 'bottom'
        };
        // set current popper element so that it could be destroy later.

        this.currentPopperElement = createPopper(target, content, options);
        this.initArrow();
    }

    private destroyPopOver() {
        if (this.currentPopperElement != null) {
            this.currentPopperElement.destroy();
            this.currentPopperElement = null;
        }
    }

    // used to update state and make sure style is kept
    private updateState(state: State) {
        this.state = state;
        // update popover posotion since size of panel could be diferent.
        if (this.currentPopperElement) {
            this.currentPopperElement.update();
        }
    }

    // request count
    private requestStatistics(forceRequest: boolean) {
        if (this.statisticsPanel.justListen) {
            this.panelIsVisible = false;
        } else {
            this.panelIsVisible = true;
        }
        this.apiCreateOrGetStatisticsRequest(forceRequest);
    }

    // check count status
    private requestStatusCheck() {
        this.panelIsVisible = true;
        this.handleRequestStatisticsInProgress(this.statisticsPanel.requestIdSafe);
        if (this.looping) {
            this.updateState(State.Generating);
            return;
        }
    }

    // create or get statics request
    // if forceRequest is set to true then it will create a new request else it will try to get if exists.
    private apiCreateOrGetStatisticsRequest(forceRequest: boolean) {
        if (this.statisticsPanel.statisticsService == null) {
            this.disableGenerate = false;
            this.showError('An error occurred while generating the counts.');
            return;
        }

        this.statisticsPanel.statisticsService.getStatisticsRequestId(forceRequest)
            .then((response) => {
                if (response.data.status === 200 && response.data.data != null && response.data.data! > 0) {
                    this.handleRequestStatisticsInProgress(response.data.data!);
                } else {
                    this.disableGenerate = false;
                    this.showError('An error occurred while generating the counts.');
                }
            })
            .catch(() => this.handleRequestStatisticsError());
    }

    private handleRequestStatisticsError() {
        this.disableGenerate = false;
        this.showError('An error occurred while generating the counts.');
    }

    private apiGetStatistics() {
        if (this.looping === false) {
            return;
        } else if (
            this.statisticsPanel.statisticsService === null ||
            this.statisticsPanel.statisticsService.requestId < 1
        ) {
            this.showError('An error occurred while generating the counts.');
            return;
        }
        this.statisticsPanel.statisticsService.getStatistics()
            .then((response) => {
                if (response.data.data) {
                    this.handleRequestStatisticsCompleted(response.data);
                } else {
                    this.showError('An error occurred while generating the counts.');
                }
            })
            .catch(() => this.handleRequestStatisticsError());
    }

    // Render statistics for user
    private handleRequestStatisticsCompleted(data: StatisticsRequestResponseModel) {
        // update new entries
        this.updateComponentWithNewStatistics(data);
        // emit new total count
        const completed: any = {
            totalCount: this.lastTotalCount,
            uniqueCount: this.lastUniqueCount,
            detailId: this.statisticsPanel.detailId
        };
        this.$emit('onCompleted', completed);
        this.statisticsPanel.statisticsService.resetRequestId();
        this.looping = false;
        this.updateState(State.CountsResloved);
        this.placeArrow();
    }

    // Keep checking statistic's status
    private handleRequestStatisticsInProgress(requestId: number) {
        // if new requestId them emit onGenerationg. Event should only emit one time.
        if (requestId !== this.statisticsPanel.requestId) {
            this.currentlyGenerating = {
                detailId: this.statisticsPanel.detailId,
                requestId
            };
        } else {
            this.currentlyGenerating = null;
        }

        this.statisticsPanel.requestId = requestId;
        this.apiCheckStatisticsRequestStatus();
    }

    // checks request status and calls it self if the status is in process
    // if it compleates then it gets the status
    private apiCheckStatisticsRequestStatus() {
        if (this.statisticsPanel.statisticsService == null) {
            this.showError('An error occurred while generating the counts.');
        } else if (this.statisticsPanel.statisticsService.requestId < 1) {
            this.showError('An error occurred while generating the counts.');
        }
        this.looping = true;
        if (this.requesting == null) {
            this.requesting = this.statisticsPanel.requestId;
        }
        this.statisticsPanel.statisticsService.checkStatisticsStatus()
            .then((response) => {
                this.requesting = null;
                if (response.data.data) {
                    const result: StatisticsStatusResponseModel = response.data;
                    this.handleCheckStatisticsStatus(result.data.status, result.data.cancelled_by_user);
                    this.getSetNotificationToggle(result.data.hasEmailNotification);
                } else {
                    this.disableGenerate = false;
                    this.showError('An error occurred while generating the counts.');
                }
            }).catch(() => {
                this.disableGenerate = false;
                this.showError('An error occurred while generating the counts.');
            });
    }

    private handleCheckStatisticsStatus(status: number, cancelledByUser: string) {
        this.cancelledByUser = cancelledByUser;
        const detailId: number = this.statisticsPanel.detailId;
        switch (status) {
            case CriteriaRequestStatusType.Complete:
                // statistics request completed, get statistics
                this.apiGetStatistics();
                break;
            case CriteriaRequestStatusType.Submitted:
            case CriteriaRequestStatusType.InProcess:
                // If in process, check again in one second if status has changed.
                this.disableGenerate = false;
                this.updateState(State.Generating);
                if (this.currentlyGenerating != null && this.currentlyGenerating.requestId !== this.requesting) {
                    this.$emit('onGenerating', this.currentlyGenerating);
                }
                const that: any = this;
                this.currentInterval = setTimeout(() => {
                    if (that.looping) {
                        that.apiCheckStatisticsRequestStatus();
                    }
                }, apiIntervalFrequency);
                break;
            case CriteriaRequestStatusType.CancelledByUser:
                this.updateState(State.Cancelled);
                this.$emit('onCancel', {
                    detailId
                });
                break;
            default:
                this.disableGenerate = false;
                this.showError('An error occurred while generating the counts.');
                this.$emit('onError', {
                    detailId
                });
                break;
        }
    }

    // Update entries with new statistics data received
    private updateComponentWithNewStatistics(data: StatisticsRequestResponseModel) {
        this.currentStatistics = data;
        if (this.currentStatistics != null) {
            // set unique entries
            this.uniqueEntries = [{
                key: 'Unique',
                value: Common.formatCounts(this.currentStatistics.data.count_unique)
            }];
            // set entries
            this.entries = [
                {
                    key: 'Total Count',
                    value: Common.formatCounts(this.currentStatistics.data.count_total)
                },
                {
                    key: 'Null',
                    value: Common.formatCounts(this.currentStatistics.data.count_null)
                },
                {
                    key: 'Invalid',
                    value: Common.formatCounts(this.currentStatistics.data.count_invalid)
                },
                // {
                //    key: 'Null or Invalid',
                //    value: Common.formatCounts(this.currentStatistics.data.count_null_or_invalid)
                // },
                // {
                //    key: 'Unused Status',
                //    value: Common.formatCounts(this.currentStatistics.data.count_unused_status)
                // },
                {
                    key: 'Unsubscribed',
                    value: Common.formatCounts(this.currentStatistics.data.count_unsubscribed)
                },
                {
                    key: 'Bounced',
                    value: Common.formatCounts(this.currentStatistics.data.count_bounced)
                },
                {
                    key: 'Non-Consent',
                    value: Common.formatCounts(this.currentStatistics.data.count_non_consent)
                },
                {
                    key: 'Flagged',
                    value: Common.formatCounts(this.currentStatistics.data.count_flagged)
                },
                {
                    key: 'Valid',
                    value: Common.formatCounts(this.currentStatistics.data.count_valid)
                }
            ];
            const timezone = systemTimezone();
            this.entriesGeneratedDate = 'Last run on ' +
                Common.formatDateTime(this.currentStatistics.data.generated_on)
                + ' (' + timezone + ')';
            this.lastTotalCount = this.currentStatistics.data.count_total;
            this.lastUniqueCount = this.currentStatistics.data.count_unique;
        }
    }

    private isUpdatingNotification() {
        return this.updatingNotification;
    }

    private notificationChangeHandler() {
        if (this.updatingNotification) {
            return;
        }
        const sendNotification: boolean = this.getSetNotificationToggle();
        this.updatingNotification = true;

        this.statisticsPanel.statisticsService.statisticsSetNotification(sendNotification)
            .then(() => {
                this.updatingNotification = false;
            })
            .catch(() => {
                this.updatingNotification = false;
                console.log('An error occurred while updating notification.');
            });

    }

    private getSetNotificationToggle(value: boolean | null = null): boolean {
        if (value != null) {
            (document.getElementById('notificationToggle') as any).checked = value;
        }
        return (document.getElementById('notificationToggle') as any).checked;
    }

    // #endregion
}

